import React from "react"
import {Application, approveApplication} from "../../resources/application"
import useAsyncResultIdle from "../../hooks/useAsyncResultIdle"
import {useAccessToken} from "../../services/auth"
import {useAsyncResult} from "../../hooks/useAsyncResult"
import {getDefaultRiskRate} from "../../resources/org"
import Loading from "../Loading/Loading"
import {Err} from "../Err/Err"
import {ApproveApplicationModal} from "./ApplicationApprove"

interface OnboardingApproveModalProps {
	application: Application
	close: () => void
	onSuccess: () => void
}

export function ApproveOnboardingApplicationModal({application, close, onSuccess}: OnboardingApproveModalProps) {
	const accessToken = useAccessToken()
	const [state, approve] = useAsyncResultIdle(approveApplication)
	const result = useAsyncResult(() => getDefaultRiskRate(accessToken, application.relationships.org.data.id))
	return result.match(
		() => <Loading />,
		(defaultRiskRate) => (
			<ApproveApplicationModal
				title="Approve Customer"
				close={close}
				onSuccess={onSuccess}
				state={state}
				showRiskRate={true}
				defaultRiskRate={defaultRiskRate}
				approveFn={(reason, riskRate) =>
					approve(accessToken, application, reason, riskRate, application.attributes.updatedAt)
				}
			/>
		),
		(err) => <Err err={err} />
	)
}
